interface PageHeaderProps {
    subTitle?: string;
    title: string;
}

export function PageHeader({subTitle, title}: PageHeaderProps) {
    return (
        <div className="page-header">
            {subTitle && <div className="page-header__sub">{subTitle}</div>}
            <div className="page-header__main">{title}</div>
        </div>
    );
}
